import React, { useState, useEffect} from 'react';
import NET from 'vanta/dist/vanta.net.min'
import styles from './Trouble.module.css'
import ThreeItem from './ThreeItem'

const Trouble = () => {
    const [vantaEffect, setVantaEffect] = useState(null);
    const [xOffsetValue, setXOffsetValue] = useState(window.innerWidth <= 768 ? 0 : -0.1);
    const [yOffsetValue, setYOffsetValue] = useState(0.15);
    const [sizeValue, setSizeValue] = useState(0.8);

    const updateValues = () => {
        setXOffsetValue(window.innerWidth <= 768 ? 0 : -0.1);
        setYOffsetValue(window.innerWidth <= 768 ? 0 : 0.15);
        setSizeValue(window.innerWidth <= 768 ? 0.6 : 0.8);
    };

    useEffect(() => {
        window.addEventListener('resize', updateValues);

        // Initial check
        updateValues();

        return () => {
            window.removeEventListener('resize', updateValues);
        };
    }, []);

    useEffect(() => {
        if (!vantaEffect) {
            setVantaEffect(NET({
                el: "#vanta2",
                mouseControls: true,
                touchControls: true,
                gyroControls: false,
                scale: 1.00,
                scaleMobile: 1.00,
                color: 0x6c3fff,
                backgroundColor: 0x030014,
                points: 12.00,
                maxDistance: 33.00,
                spacing: 13.00,
                showDots: false,
                speed:4.0,
                blurFactor: 1.0,
                zoom:1.0
            }));
        }
        return () => {
            if (vantaEffect) vantaEffect.destroy();
        };
    }, [vantaEffect, xOffsetValue, yOffsetValue, sizeValue]);
  return (
    <section className={styles.trouble_area}>
        <h2>こんな<span>お悩み</span>はありませんか？</h2>
        <div className={styles.contents}>
            <div>
                <span>ランディングページが急遽必要になってしまった</span>
            </div>
            <div>
                <span>CVRがなかなか改善しなくて早急に解決したい</span>
            </div>
            <div>
                <span>現在使用しているランディングページを変えたい</span>
            </div>
            <div>
                <span>大至急イベントのためのページが必要になった</span>
            </div>
            <div>
                <span>新たなサービスの立ち上げが急遽決まった</span>
            </div>
        </div>
        <ThreeItem />
        <div className={styles.vanta} id='vanta2'></div>
    </section>
  )
}

export default Trouble